import { render, staticRenderFns } from "./EventUnits.vue?vue&type=template&id=13eae370&"
import script from "./EventUnits.vue?vue&type=script&lang=js&"
export * from "./EventUnits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports